import { render, staticRenderFns } from "./PaywayNotAvailable.vue?vue&type=template&id=72b292f9&scoped=true"
import script from "./PaywayNotAvailable.vue?vue&type=script&lang=js"
export * from "./PaywayNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./PaywayNotAvailable.vue?vue&type=style&index=0&id=72b292f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b292f9",
  null
  
)

export default component.exports